// src/design-system/Skeleton.tsx
import clsx from "clsx";
import type { CSSProperties } from "react";

/** شريط نابض واحد — لبناء هياكل تحميل (Skeleton) مخصصة داخل أي صفحة. */
export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return (
    <div
      className={clsx("animate-pulse rounded-md bg-line-2", className)}
      style={{ opacity: 0.5, ...style }}
      aria-hidden
    />
  );
}

/**
 * هيكل تحميل عام لصفحة كاملة (رأس + شبكة بطاقات + جدول) — يُستخدم كـ pendingComponent
 * للراوتر عشان الانتقال بين المسارات يحس فوري: الزر يستجيب على طول، والانتظار الفعلي
 * (استيراد حزمة الصفحة + أي طلب بيانات) بيتحرك جوه المسار الهدف بالهيكل ده لحد ما يجهز.
 */
export function RouteSkeleton() {
  return (
    <div className="app-bg min-h-screen p-6" role="status" aria-live="polite" aria-label="جارٍ التحميل">
      <div className="mb-6 flex items-center justify-between">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-9 w-28" />
      </div>
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="glass flex flex-col gap-2 p-[18px]">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-7 w-24" />
          </div>
        ))}
      </div>
      <div className="glass-flat overflow-hidden">
        <div className="border-b border-line px-5 py-3.5"><Skeleton className="h-4 w-32" /></div>
        <div className="flex flex-col gap-3 p-5">
          {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-5 w-full" />)}
        </div>
      </div>
    </div>
  );
}
